export const parseToNumber = value => {
  return Number(value.toString().replace(/[^0-9]/g, ''))
}

export const parseToString = value => {
  return value.replace(/[^0-9]/g, '')
}
